import { FcmService } from './../services/fcm.service';
import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private alertController: AlertController,
    private router: Router,
    private fcm: FcmService
  ) {}
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const uid = await this.auth.uid();

    const isLoggedIn = !!uid;

    if (!isLoggedIn) {
      // tslint:disable-next-line: max-line-length
      const alert = await this.alertController.create({
        header: 'You are not logged in.',
        message: 'You must be logged in to view this page.',
        buttons: ['OK'],
      });
      await alert.present();
      this.router.navigateByUrl('/');
    }

    return isLoggedIn;
  }
}
